import { HttpErrorResponse } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { ProjectDetailResponse } from '../../../features/feature-project-details/models/project-detail.interface'
import { Consortium } from '../../../features/feature-project-details/models/consortium.interface'
import { FinalProposal } from '../../../features/feature-project-details/models/final-proposal.interface'

export const retriveProject = createAction('[project-detail] Retriving project', props<{ id: string; status: string }>())

export const retriveProjectSuccess = createAction('[project-detail] Retriving project SUCCESS', props<{ result: ProjectDetailResponse }>())

export const retriveProjectFailure = createAction('[project-detail] Retriving project FAILURE', props<{ error: HttpErrorResponse }>())

export const cleanProjectDetail = createAction('[project-detail] Cleaning data')

export const retriveProjectConsortium = createAction('[project-detail] Retriving project consortium', props<{ id: string }>())

export const retriveProjectConsortiumSuccess = createAction('[project-detail] Retriving project consortium SUCCESS', props<{ result: Consortium }>())

export const retriveProjectConsortiumFailure = createAction('[project-detail] Retriving project consortium FAILURE', props<{ error: HttpErrorResponse }>())

export const retriveProjectFinalProposals = createAction('[project-detail] Retriving final proposals', props<{ id: string }>())

export const retriveProjectFinalProposalsSuccess = createAction('[project-detail] Retriving final proposals SUCCESS', props<{ result: FinalProposal[] }>())

export const retriveProjectFinalProposalsFailure = createAction('[project-detail] Retriving final proposals FAILURE', props<{ error: HttpErrorResponse }>())

export const downloadFinalProposal = createAction('[project-detail] Final proposal DOWNLOADING', props<{ projectId: string; fileId: string }>())

export const downloadFinalProposalSuccess = createAction('[project-detail] Final proposal DOWNLOADING  SUCCESS')

export const downloadFinalProposalFailure = createAction('[project-detail] Final proposal DOWNLOADING FAILURE', props<{ error: HttpErrorResponse }>())
